// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_MUSHROOM_PEOPLE = [{
  id: 'mushroom_people_spore',
  factionId: FACTIONS.MUSHROOM_PEOPLE,
  name: 'Отец спор',
  priceNumens: 9000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.LIGHT_GREEN
  ]
}, {
  id: 'mushroom_people_since',
  factionId: FACTIONS.MUSHROOM_PEOPLE,
  name: 'Ученый микоид',
  priceNumens: 23000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.CELADON,
  ]
}, {
  id: 'mushroom_people_jelly',
  factionId: FACTIONS.MUSHROOM_PEOPLE,
  name: 'Слизняк',
  priceNumens: 80000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.PINK,
  ]
}, {
  id: 'mushroom_people_gold_legacy',
  factionId: FACTIONS.MUSHROOM_PEOPLE,
  name: 'Медовый обжора',
  priceNumens: 130000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'mushroom_people_ruby_legacy',
  factionId: FACTIONS.MUSHROOM_PEOPLE,
  name: 'Кровавый мухомор',
  priceCrystals: 450,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
